export default "__VITE_ASSET__B1aGnler__"